<template>
  <a-upload
    name="Attachment"
    :action="BASEURL+'api/annex/uploads'"
    :data="{path:'file'}"
    list-type="text"
    :file-list="fileList"
    @change="handleUpload"

    v-bind="$attrs"
    v-on="$listeners"
  >
  <a-button><a-icon type="upload"/> 点击上传</a-button>
</a-upload>
</template>
<script>
  export default {
    name: 'OneUpload',
    props: {
      value:{type:String, default:""},
      baseUrl:{type:String, default:(process.env.VUE_APP_BASEURL?process.env.VUE_APP_BASEURL:'/')+"RESOURCE"},
    },
    model: {
      prop: "value",
      event: 'upload'
    },
    data() {
      return {
        url:"",
        fileList:[],
      }
    },
    watch:{
      value:{
        immediate:true,
        handler(newvalue, oldvalue){
          this.url = newvalue;
          if (!newvalue) {
            this.fileList = [];
          } else {
            const name = newvalue.substring(newvalue.lastIndexOf("/")+1);
            // console.log(name);
            this.fileList = [{
              uid:-1,name:name,url:this.baseUrl + "/" + newvalue,status:"done"
            }];
          }
        }
      }
    },
    methods:{
      handleUpload(info) {
        // console.log(info);
        let fileList = [...info.fileList];
        fileList = fileList.slice(-1);
        fileList = fileList.map(file => {
          if (file.response) {
            // console.log(file.response);
            const res= file.response.data.items[0];
            this.url = res.file_path + "/" + res.file_name;
            file.url = this.baseUrl + "/" + res.file_path + "/" + res.file_name;
          }
          return file;
        });
        this.fileList = fileList;
        this.$emit("upload", this.url);
      }
    }
  }
</script>
